<template>
    <v-card outlined>
        <div>
            <v-card-title
            v-if="mode=='create'"
                class="subtitle-3 d-flex"
                style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap;"
            >
                <v-btn
                    class="text-capitalize"
                    depressed
                    elevation="8"
                    fab
                    dark
                    @click="$emit('prev')"
                >
                    <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
                </v-btn>

                <span class="text-h4 pl-5 pr-5">{{
                    newCampaign.category &&translations[newCampaign.category + "TitleStep2"]&&
                        translations[newCampaign.category + "TitleStep2"][lang]
                }}</span>

                <v-btn
                    class="text-capitalize"
                    depressed
                    :elevation="(canGoToNextStep && !loading && 8) || 0"
                    dark
                    fab
                    :disabled="!canGoToNextStep || loading"
                    @click="goToNextStep()"
                >
                    <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="text--primary pt-5">
                <div v-if="newCampaign.category == 'informative'">
                    <Step2Informative />
                </div>
                <div v-else-if="newCampaign.category == 'action'">
                    <Step2Action />
                </div>
            </v-card-text>
        </div>

        <v-divider></v-divider>
    </v-card>
</template>

<script>
import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import Step2Informative from "@/components/loyaltyPanel/newCampaign/Step2Informative";
import Step2Action from "@/components/loyaltyPanel/newCampaign/Step2Action";

export default {
    name: "Step2",

    mixins: [translations],

    components: { Step2Informative, Step2Action },
    props: {
        mode: {
            type: String,
            default: 'create'
        },
    },
    data: () => ({
        icons: {
            mdiArrowLeft,
            mdiArrowRight
        }
}),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", ["canGoToNextStep"]),
        ...mapState(["loading"]),
        lang() {
            return this.$route.params.lang;
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        }
    },

    methods: {
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setNewCampaign",
            "setCanGoToNextStep"
        ]),


        goToNextStep() {
            this.$emit("next");
        }
    },

};
</script>
<style scoped>
.deleteDateTime {
    cursor: pointer;
    padding: 1px 8px 3px 8px;
    margin-bottom: 15px;
    border-radius: 15px;
}
.deleteDateTime:hover {
    font-weight: 550;
    background-color: rgba(0, 0, 0, 0.2);
}
.calendar-col {
    transition: all 0.5s ease-in-out;
}
.datetimes-col {
    transition: all 0.8s ease-in-out;
}
</style>
